import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { Routes } from 'utils/routes';
import ARTICLE_QUERY from 'queries/articles/article';
import Query from './Query';
import ArticlesPreviews from './ArticlesPreviews';

const ArticlePreview = ({ firstArticleSlug, secondArticleSlug, style, classNames = '' }) => (
    <article className={ `articlePreviews${  classNames}` } style={ style }>
        <Query query={ ARTICLE_QUERY } slug={ firstArticleSlug }>
            { ({ data }) => (
                <ArticlePreviewSection article={ data?.articleEntries?.[0] } slug={ firstArticleSlug } />
            ) }
        </Query>
        <Query query={ ARTICLE_QUERY } slug={ secondArticleSlug }>
            { ({ data }) => (
                <ArticlePreviewSection article={ data?.articleEntries?.[0] } slug={ secondArticleSlug } />
            ) }
        </Query>
    </article>
);

function ArticlePreviewSection({ article, slug }) {
    const router = useRouter();
    if (!article) return <ArticlesPreviews onlySections={ true } firstArticleId={ slug } />;
    return (
        <section>
            <div
                style={{ backgroundImage: `url(${article.hero.url})` }}
                onClick={ () => router.push(Routes.Articles.Article(article.slug)) }
            />
            <div>
                <h3>{ article.meta.page_title }</h3>
                <p>{ article.meta.page_description }</p>
                <a onClick={ () => router.push(Routes.Articles.Article(article.slug)) }>Læs mere</a>
            </div>
        </section>
    );
}

ArticlePreview.propTypes = {
    firstArticleSlug: PropTypes.string.isRequired,
    secondArticleSlug: PropTypes.string.isRequired,
    style: PropTypes.object,
    classNames: PropTypes.string,
};

export default ArticlePreview;
